import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

function RSVPGroups({ rsvpGroups, setRsvpGroups, setSelectedRSVP, allResponses, error, loading }) {
    const [searchParams] = useSearchParams();
    const name = searchParams.get("guest") || "";
    const navigate = useNavigate();

    useEffect(() => {
        if (rsvpGroups.length === 0) {
            let foundGroups = allResponses.filter(response => response.guests.some(guest => guest.name.toLowerCase() === name.toLowerCase()))
            setRsvpGroups(foundGroups)
        }
    }, [allResponses]);

    return (
        <div className="space-y-4 flex flex-col items-center">
            {error ? <p className="text-red-400">Website Error! Failed to fetch guests information. Please reach out to Thuyan to get this fixed.</p> :
                <>
                    {(!loading && rsvpGroups.length === 0) ? <p>Guest Not Found</p> :
                        <>
                            {rsvpGroups.length > 0 && <p>Please {rsvpGroups.length === 1 ? "confirm" : "select"} your group:</p>}
                            {rsvpGroups.map(rsvp => (
                                <div key={rsvp._id} className="p-4 space-y-3 rounded border bg-white w-80">
                                    <div>
                                        {rsvp.guests.map(guest => {
                                            return (
                                                guest["is_plus_one"] ?
                                                    <div className="italic" key={guest.name}>plus one additional guest</div> :
                                                    <div key={guest.name}>{guest.name}</div>
                                            )
                                        })}
                                    </div>
                                    <button
                                        className="border-2 hover:bg-rose hover:text-white bg-blush border-rose text-customGray py-1 px-2 rounded"
                                        onClick={() => {
                                            const selected = allResponses.find(response => response._id === rsvp._id);
                                            setSelectedRSVP(selected);
                                            setRsvpGroups([]);
                                            navigate(`/rsvp/form?response=${rsvp._id}`)
                                        }}
                                    >
                                        {rsvpGroups.length === 1 ? "Confirm" : "Select"}
                                    </button>
                                </div>
                            ))}
                        </>
                    }
                    <div className="h-2"></div>
                    <p
                        className="pb-8 back-to-search text-base text-bronze hover:text-gold hover:underline hover:cursor-pointer"
                        onClick={(e) => {
                            navigate(`/rsvp`);
                        }}>
                        Go Back
                    </p>
                </>
            }
        </div>
    )
}

export default RSVPGroups